import { Injectable, signal } from '@angular/core';

@Injectable()
export class BuildCampaignDialogService {
  private readonly _smlModalMounted = signal(false);
  private readonly _smlModalOpen = signal(false);
  private readonly _completeCampaignModalMounted = signal(false);
  private readonly _completeCampaignModalOpen = signal(false);
  private readonly _reactivateCampaignModalMounted = signal(false);
  private readonly _reactivateCampaignModalOpen = signal(false);

  readonly smlModalMounted = this._smlModalMounted.asReadonly();
  readonly smlModalOpen = this._smlModalOpen.asReadonly();
  readonly completeCampaignModalMounted = this._completeCampaignModalMounted.asReadonly();
  readonly completeCampaignModalOpen = this._completeCampaignModalOpen.asReadonly();
  readonly reactivateCampaignModalMounted = this._reactivateCampaignModalMounted.asReadonly();
  readonly reactivateCampaignModalOpen = this._reactivateCampaignModalOpen.asReadonly();

  openSmlModal(): void {
    this._smlModalMounted.set(true);
    this._smlModalOpen.set(true);
  }

  closeSmlModal(): void {
    if (!this._smlModalMounted()) return;
    this._smlModalOpen.set(false);
    setTimeout(() => this._smlModalMounted.set(false), 800);
  }

  openCompleteCampaignModal(): void {
    this._completeCampaignModalMounted.set(true);
    this._completeCampaignModalOpen.set(true);
  }

  closeCompleteCampaignModal(): void {
    if (!this._completeCampaignModalMounted()) return;
    this._completeCampaignModalOpen.set(false);
    setTimeout(() => this._completeCampaignModalMounted.set(false), 800);
  }

  openReactivateCampaignModal(): void {
    this._reactivateCampaignModalMounted.set(true);
    this._reactivateCampaignModalOpen.set(true);
  }

  closeReactivateCampaignModal(): void {
    if (!this._reactivateCampaignModalMounted()) return;
    this._reactivateCampaignModalOpen.set(false);
    setTimeout(() => this._reactivateCampaignModalMounted.set(false), 800);
  }
}
